import { IntlShape } from 'react-intl';

import { IDriverBrief } from '@/modules/driver/model';
import { TestDefinition } from '@/modules/partner/model/test-definition';
import { eventTracking } from '@/services/event-tracking';
import { TLanguageTag } from '@/services/userLanguage';

import { ICard, TCardStatus } from '../types';

const getTestCard =
  ({
    cardStatus,
    actionTitle,
    language,
  }: {
    cardStatus: TCardStatus;
    actionTitle: string;
    language: TLanguageTag;
  }) =>
  (test: TestDefinition) => {
    const title = test.localizedTitle[language] || test.title;
    const description = test.localizedDescription[language] || test.description;

    return {
      id: `test-${test.id}`,
      isBlocked: false,
      cardStatus,
      title,
      desc: <span dangerouslySetInnerHTML={{ __html: description }} />,
      actionTitle,
      actionTracker: () => {
        eventTracking.trackSnowplow({
          event: 'Onboarding - Test - Open',
          name: test.title,
          id: test.id,
        });
      },
      actionExternalLink: test.eLearningModuleLink,
    };
  };

const createTestCards = (
  {
    myDriver,
    allTestDefinitions,
  }: {
    myDriver: IDriverBrief | undefined;
    allTestDefinitions: TestDefinition[];
  },
  intl: IntlShape,
  language: TLanguageTag,
): ICard[] => {
  if (!myDriver) {
    return [];
  }

  const actionTitle = intl.formatMessage({
    defaultMessage: 'Start the module',
    id: 'a/BSJt',
    description: 'todo list card text',
  });

  if (!myDriver) {
    return [];
  }

  const passedTests = allTestDefinitions.filter(
    test => myDriver.testStatuses[test.id] === 'passed',
  );
  const requiredTests = allTestDefinitions.filter(
    test => myDriver.testStatuses[test.id] === 'pending',
  );
  const rejectedTests = allTestDefinitions.filter(
    test => myDriver.testStatuses[test.id] === 'failed',
  );

  return [
    ...passedTests.map(getTestCard({ cardStatus: 'done', actionTitle, language })),
    ...rejectedTests.map(getTestCard({ cardStatus: 'rejected', actionTitle, language })),
    ...requiredTests.map(getTestCard({ cardStatus: 'todo', actionTitle, language })),
  ];
};

export { createTestCards };
